import React from 'react';
import { navigate } from 'gatsby';
import Store from './src/context/Store';
import Layout from 'pwplayout'; // see gatsby-node.js->webpack-config->resolve.alias... for resolution of this module
import SentryTracking from './src/components/SentryTracking';
import GoogleTracking from './src/components/GoogleTracking';

/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

export let wrapPageElement = ({ element, props }) => {
  // Prevent layout wrapper with createPage({context: {useLayout: false})
  let { location } = props;
  if (location.hash.startsWith('#/')) {
    let newDestination = location.hash.replace('#', '');
    navigate(newDestination, { replace: true });
  }

  if (props.pageContext.useLayout === false) {
    return element;
  } else {
    return <Layout {...props}>{element}</Layout>;
  }
};

export let wrapRootElement = ({ element }) => {
  return (
    <Store>
      <SentryTracking />
      <GoogleTracking />
      {element}
    </Store>
  );
};

export let shouldUpdateScroll = ({ routerProps, prevRouterProps = { location: undefined } }) => {
  const { location } = routerProps;
  const { location: prevLocation } = prevRouterProps;

  let strippedPathname = location.pathname.replace(/\/$/, '');
  let strippedPrevPathname = prevLocation?.pathname.replace(/\/$/, '');
  if (location?.hash && strippedPathname === strippedPrevPathname) return false; // hand over scroll handling to <Layout> when previous and current page is the same
  if (location?.state?.anchor || location?.state?.modal || location?.state?.workspaceToggle) return false; // prevent scroll when modal|workspacesToggle flag is passed in

  return true;
};
